import { useEffect } from 'react'

/**
 * Hook to handle Escape key press to close modals or dismiss UI elements
 *
 * @param {boolean} isActive - Whether the handler should be active (e.g., modal is open)
 * @param {function} onEscape - Callback to run when Escape is pressed
 */
export function useEscapeKey(isActive, onEscape) {
  useEffect(() => {
    if (!isActive) return

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault()
        onEscape()
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [isActive, onEscape])
}

export default useEscapeKey
